<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-area
            type="fieldset"
            title="Profissional responsável"
            show-legend
        >
            <FormCadastro
                 ref="FormCadastro"
                :data="data"
            />
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Identificação do paciente"
        >
            <FormCidadao
                :data="data"
            />
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Informação Sociodemográfica"
        >
            <FormInformacao
                :data="data"
                @mudanca-territorio="handleMudancaTerritorio"
            />
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Informação Socioeconômica"
        >
            <FormSocioeconomica
                :data="data"
            />
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="RECUSA DO CADASTRO INDIVIDUAL DA ATENÇÃO BÁSICA"
        >
            <FormRecusa
                :data="data"
            />
        </rkm-area>

        <rkm-area
            type="fieldset"
            title="Criação e alteração do Cadastro Individual"
            v-if="data.model.alteracao.dataCadastro !== null"
        >
            <FormAlteracao
                :data="data"
            />
        </rkm-area>
    </rkm-form>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

// Components
import FormCidadao from './components/cidadao/Form.vue'
import FormCadastro from './components/cadastro/Form.vue'
import FormInformacao from './components/informacao/Form.vue'
import FormAlteracao from './components/alteracao/Form.vue'
import FormRecusa from './components/recusa/Form.vue'
import FormSocioeconomica from './components/socioeconomica/Form.vue'

export default {
    components: {
        FormCidadao,
        FormCadastro,
        FormInformacao,
        FormAlteracao,
        FormRecusa,
        FormSocioeconomica
    },
    data: () => ({
        model: null,
        form: null,
    }),
    methods: {
        async validate() {

            return this.$refs.Form.validate()
        },
        handleMudancaTerritorio() {
           this.$refs.FormCadastro?.limparResponsavel()
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    }
}

</script>